<template>
    <div class="grey lighten-5 container-height">
        <div class="white">
            <v-container class="content-container">
                <v-row>
                    <v-col>
                        <h1>
                            Account
                        </h1>
                    </v-col>
                </v-row>
            </v-container>
            <v-divider>
            </v-divider>
        </div>
        <v-container class="content-container">
            <alert-bar
                class="mt-4"
                dismissible
                :message="message"
                :notification-type="type"
                @dismiss="[message = null, type = null]">
            </alert-bar>
            <v-row>
                <v-col
                    cols="12"
                    md="6">
                    <v-card
                        outlined
                        class="mb-4">
                        <v-card-text>
                            <h2>
                                <v-icon class="mt-n1 black--text">
                                    mdi-account-outline
                                </v-icon>
                                Personal Details
                            </h2>
                            <loading-linear
                                v-if="loading.user"
                                :show-message="false"
                                container-padding="px-0 pt-8 pb-4">
                            </loading-linear>
                            <template v-else>
                                <p class="font-weight-bold mt-4 mb-1">
                                    Name
                                </p>
                                <p v-if="name">
                                    {{ name }}
                                </p>
                                <p class="font-weight-bold mt-4 mb-1">
                                    Email
                                </p>
                                <p
                                    v-if="email"
                                    class="mb-0">
                                    {{ email }}
                                </p>

                                <p class="font-weight-bold mt-4 mb-1">Phone</p>

                                <v-text-field
                                        label="Phone"
                                        v-model="phoneNumber"
                                        maxLength="32"
                                        outlined
                                        dense
                                ></v-text-field>

                                <h3 class="my-2">Work</h3>

                                <v-select
                                        label="Industry"
                                        v-model="industry_id"
                                        :items="industries"
                                        clearable
                                        outlined
                                        dense
                                        :menu-props="{ bottom: true, offsetY: true }"
                                ></v-select>

                                <v-text-field
                                        v-if="isCustomIndustryVisible"
                                        label="Custom Industry"
                                        v-model="industry_custom"
                                        maxLength="255"
                                        outlined
                                        dense
                                ></v-text-field>

                                <v-text-field
                                        label="Job Role"
                                        v-model="job_role"
                                        maxLength="128"
                                        outlined
                                        dense
                                ></v-text-field>

                                <v-autocomplete
                                        label="Primary Location"
                                        v-model="location_name"
                                        :items="locationOptions"
                                        clearable
                                        outlined
                                        dense
                                        :menu-props="{ bottom: true, offsetY: true }"
                                ></v-autocomplete>

                                <h3 class="my-3">Organization</h3>

                                <v-text-field
                                        label="Company Name"
                                        v-model="company_name"
                                        maxLength="255"
                                        outlined
                                        dense
                                ></v-text-field>

                                <v-select
                                        label="Number of Employees"
                                        v-model="organization_size"
                                        :items="organizationSizeOptions"
                                        clearable
                                        outlined
                                        dense
                                        :menu-props="{ bottom: true, offsetY: true }"
                                ></v-select>

                                <v-btn color="primary"
                                       :loading="formSaving"
                                       :disabled="formSaving"
                                       @click.prevent="savePersonalDetails">Save Changes
                                </v-btn>

                            </template>
                        </v-card-text>
                    </v-card>
                    <v-card outlined>
                        <v-card-text>
                            <h2>
                                <v-icon class="mt-n1 black--text">
                                    mdi-shield-outline
                                </v-icon>
                                Security
                            </h2>
                            <p class="font-weight-bold mt-4 mb-1">
                                Password
                            </p>
                            <p>
                                Your password can be changed on your myICC account.
                            </p>
                            <a
                                class="font-weight-bold"
                                href="https://my.iccsafe.org/profile/info/change-password"
                                title="Manage Password"
                                target="_blank">
                                Manage Password
                            </a>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    md="6">
                    <v-card outlined>
                        <v-card-text>
                            <h2>
                                <v-icon class="mt-n1 black--text">
                                    mdi-cog-outline
                                </v-icon>
                                Preferences
                            </h2>

                            <loading-linear
                                    v-if="loading.user"
                                    :show-message="false">
                            </loading-linear>

                            <template v-else>

                                <p class="font-weight-bold mt-5 mb-1">
                                    What code topics are you most interested in?
                                </p>

                                <v-select
                                        label="Topics of Interest"
                                        v-model="title_topics_selected"
                                        :items="title_topics"
                                        outlined
                                        dense
                                        multiple
                                        :menu-props="{ bottom: true, offsetY: true }"
                                ></v-select>

                                <p class="font-weight-bold mt-2 mb-1">
                                    What brings you to Digital Codes?
                                </p>

                                <v-select
                                        label="Goals"
                                        v-model="goals_selected"
                                        :items="goals"
                                        outlined
                                        dense
                                        multiple
                                        :menu-props="{ bottom: true, offsetY: true }"
                                ></v-select>

                                <v-text-field
                                        v-if="isOtherGoalSelected"
                                        label="Custom Goals"
                                        v-model="custom_goals"
                                        outlined
                                        dense
                                ></v-text-field>

                                <p class="font-weight-bold mt-4 mb-1">
                                    Title Image
                                </p>
                                <p>
                                    Title cards and title overview will display on Digital Codes with new icons or the print book cover.
                                </p>

                                <v-radio-group
                                    class="custom-radios"
                                    v-model="customPreferences[coverViewPreferenceName]">
                                    <v-radio
                                        value="icon">
                                        <template v-slot:label>
                                            <div>
                                                <p class="mb-1">
                                                    New Digital Codes icons
                                                </p>
                                                <list
                                                    listOutline
                                                    :override-cover="true"
                                                    :title="defaultTitle"
                                                    :show-version="false"
                                                    :show-favorite="false"
                                                    :show-link-icon="false">
                                                </list>
                                            </div>
                                        </template>
                                    </v-radio>
                                    <v-radio
                                        class="mt-2"
                                        value="cover">
                                        <template v-slot:label>
                                            <div>
                                                <p class="mb-1">
                                                    Print book cover (legacy)
                                                </p>
                                                <list
                                                    listOutline
                                                    width="70px"
                                                    :override-title-icon="true"
                                                    :title="defaultTitle"
                                                    :show-version="false"
                                                    :show-favorite="false"
                                                    :show-link-icon="false">
                                                </list>
                                            </div>
                                        </template>
                                    </v-radio>
                                </v-radio-group>

                                <v-btn color="primary"
                                       :loading="formSaving"
                                       :disabled="formSaving"
                                       @click.prevent="savePreferences">Save Changes
                                </v-btn>

                            </template>

                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import TitleList from "../../components/titles/cover/List.vue";

    const DEFAULT_TITLE_ID = '3309'; // 2024 IBC

    import List from "../../components/titles/cover/List.vue";
    import {ApiService} from "../../api/ApiService";
    import {AsyncUtils} from "../../util/AsyncUtils";
    import AlertBar from "../../components/notifications/AlertBar.vue";
    import LoadingLinear from "../../components/loaders/LoadingLinear.vue";
    import {BrowserUtils} from "../../util/BrowserUtils";

    export default {
        name: 'DashboardAccount',
        data() {
            return {
                formSaving: false,
                defaultTitle: null,
                email: null,
                name: null,
                phoneNumber: null,
                // work
                industry_id: null,
                industry_custom: null,
                industries: [],
                job_role: null,
                location_name: null,
                // organization
                company_name: "",
                organization_size: null,
                organizationSizeOptions: (() => {

                    const ranges = ["1 - 10", "11 - 49", "50 - 199", "200 - 499", "500 - 999", "1000+"].map((value) => {
                        return {
                            value: value,
                            text: value
                        };
                    });

                    ranges.unshift({
                        value: '',
                        text: 'unselected'
                    });

                    return ranges;
                })(),
                rules: {
                    required: (value) => {
                        if (!value) {
                            return 'Required.'
                        }
                    },
                    phone: (value) => {
                        const phoneRegex = /^\+?\d{1,3}[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}$/;
                        if (!phoneRegex.test(value)) {
                            return 'Invalid phone number format.'
                        }
                    }
                },
                // misc
                message: null,
                type: null,
                loading: {
                    user: true
                },
                title_topics_selected: [],
                title_topics: [],
                goals: [],
                goals_selected: [],
                custom_goals: null,
                // it has to be named with "preferences:" prefix for legacy reasons....
                coverViewPreferenceName: this.$getConst('preferenceKey'),
                // misc preferences
                customPreferences: {
                    // "preferences:cover_view": null,
                }
            }
        },
        computed: {
            locationOptions() {

                const cats = this.$store.getters.getSearchNavigationCategories;

                if (cats && cats.Location) {
                    return (cats.Location || []).map((item) => {
                        return item.name;
                    })
                }

                return [];
            },
            isCustomIndustryVisible() {
                return this.industry_id === -1;
            },
            selectedGoalsReal(){
                return (this.goals_selected || []).filter((item) => item > 0);
            },
            isOtherGoalSelected() {
                return (this.goals_selected || []).includes(-1);
            }
        },
        components: {
            LoadingLinear,
            AlertBar,
            TitleList,
            List
        },
        methods: {
            loadIndustries() {

                ApiService.getIndustries().then((data) => {

                    const items = (data || []).map((item) => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    });

                    // add "other"
                    items.push(
                        {value: -1, text: "Other (Please Provide)"}
                    );

                    this.industries = items;
                });
            },
            loadTitleTopics() {

                ApiService.getTitleTopics().then((data) => {
                    this.title_topics = (data || []).map((item) => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    });
                });
            },
            loadGoals() {

                ApiService.getGoals().then((data) => {

                    const items = (data || []).map((item) => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    });

                    // add "other"
                    items.push(
                        {value: -1, text: "Other (Please Provide)"}
                    );

                    this.goals = items;
                })
            },
            fetchDefaultTitle() {
                this.$http.get(Routing.generate('get_book_info', {
                    'documentId': DEFAULT_TITLE_ID
                })).then(response => {
                        if (response.data) {
                            this.defaultTitle = response.data;
                        }
                    }
                )
            },
            showSuccessMessage() {
                this.type = 'success';
                this.message = 'Account settings updated successfully';

                BrowserUtils.scrollToTopSmoothly();
            },
            showErrorMessage() {
                this.type = 'error';
                this.message = 'Failed to update account settings';

                BrowserUtils.scrollToTopSmoothly();
            },
            hideMessage() {
                this.type = null;
                this.message = null;
            },
            savePersonalDetails() {
                this.saveBothForms();
            },
            savePreferences() {
                this.saveBothForms();
            },
            saveBothForms() {
                this.formSaving = true;
                this.hideMessage();

                const payload = {
                    phone_number: this.phoneNumber,
                    industry: this.industry_id || null,
                    // only update if set to other
                    industry_other: (this.industry_id === -1) ? this.industry_custom : null,
                    job_role: this.job_role,
                    primary_location: this.location_name || null,
                    company_name: this.company_name,
                    // if it is undefined - it will not be sent otherwise
                    company_employee_count: this.organization_size || null,
                    topics: this.title_topics_selected,
                    goals: this.selectedGoalsReal,
                    // allows you to set custom goals back to empty
                    custom_goals: this.isOtherGoalSelected ? this.custom_goals : null,
                    preferences: this.customPreferences,
                };

                ApiService.updateProfileFields(payload).then(() => {
                    this.showSuccessMessage();
                }).catch(() => {
                    this.showErrorMessage();
                }).finally(() => {
                    this.formSaving = false;
                });
            }
        },
        created() {
            // to populate the "example" book for "Title Image" section
            this.fetchDefaultTitle();

            this.loadIndustries();
            this.loadTitleTopics();
            this.loadGoals();
        },
        mounted() {

            AsyncUtils.awaitUntil(() => {
                return this.$store.getters.getUser !== null && this.defaultTitle !== null;
            }, 200).then(() => {
                const user = this.$store.getters.getUser;
                this.name = user.first_name + ' ' + user.last_name;
                this.email = user.email;

                // new fields
                this.phoneNumber = user.phone_number;
                this.job_role = user.job_role;
                this.location_name = user.primary_location;
                this.company_name = user.company_name;
                this.organization_size = user.company_employee_count;

                if (user.industry_other) {
                    this.industry_id = -1;
                    this.industry_custom = user.industry_other;
                } else if (user.industry) {
                    this.industry_id = user.industry?.id;
                }

                this.title_topics_selected = (user.title_topics || []).map((item) => {
                    return item.id;
                });

                this.goals_selected = (user.goals || []).map((item) => {
                    return item.id;
                });

                // has custom goals?
                if (user.goals_custom) {
                    this.goals_selected.push(-1);
                    this.custom_goals = user.goals_custom;
                }

                const coverView = user.getPreference([this.coverViewPreferenceName]);

                if (coverView !== undefined) {
                    this.customPreferences[this.coverViewPreferenceName] = coverView;
                }

                // we have everything we need to populate BOTH sections by now
                this.$set(this.loading, 'user', false);
            });
        }
    }
</script>

<style lang="scss">
    .custom-radios {
        .v-radio {
            align-items: start;
        }
        .v-radio>.v-label {
            display: inline;
        }
    }
</style>